import ReactMarkdown from "react-markdown";
import MDBox from "components/MDBox";

const VARIANT_STYLES = {
  info: {
    border: "1px solid rgba(59, 130, 246, 0.2)",
    background: "rgba(219, 234, 254, 0.45)",
  },
  warning: {
    border: "1px solid rgba(245, 158, 11, 0.25)",
    background: "rgba(254, 243, 199, 0.5)",
  },
  success: {
    border: "1px solid rgba(16, 185, 129, 0.22)",
    background: "rgba(209, 250, 229, 0.5)",
  },
  danger: {
    border: "1px solid rgba(239, 68, 68, 0.22)",
    background: "rgba(254, 226, 226, 0.55)",
  },
};

export default function MarkdownRenderer({ content, variant = "info" }) {
  if (!content) {
    return null;
  }

  const style = VARIANT_STYLES[variant] || {
    border: "1px solid rgba(59, 130, 246, 0.14)",
    background: "rgba(255, 255, 255, 0.72)",
  };

  return (
    <MDBox
      mt={1}
      sx={{
        borderRadius: "12px",
        border: style.border,
        bgcolor: style.background,
        p: 1.5,
        fontSize: "0.8rem",
        lineHeight: 1.5,
        "& p": { m: 0, mb: 0.75 },
        "& p:last-child": { mb: 0 },
        "& ul, & ol": { m: 0, pl: 2.25, mb: 0.75 },
        "& li": { mb: 0.25 },
        "& strong": { fontWeight: 600 },
      }}
    >
      <ReactMarkdown>{content}</ReactMarkdown>
    </MDBox>
  );
}
